import React, { FC, MouseEventHandler } from "react"

import classNames from "classnames"

interface Props {
  label: string
  className: string
  onClick: MouseEventHandler
  off?: boolean
}

const Button: FC<Props> = ({ label, className, onClick, off }) => (
  <div
    className={classNames(className, {
      notiOff: off,
    })}
  >
    <a href="#!" onClick={onClick}>
      <span>{label}</span>
    </a>
  </div>
)

export default Button
